/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { NavItem } from 'reactstrap';
import { Link } from 'gatsby';

function GatsbyNavItem(props) {
	const { href, className, children, onClick } = props;
	return (
		<NavItem className={className} onClick={onClick}>
			<Link to={href} className="nav-link text-s">
				{children}
			</Link>
		</NavItem>
	);
}

GatsbyNavItem.propTypes = {
	href: PropTypes.string.isRequired,
	className: PropTypes.string,
	onClick: PropTypes.func,
};

GatsbyNavItem.defaultProps = {
	className: '',
	onClick: () => {},
};

export default GatsbyNavItem;
